import axios from 'services/network/axios';

export const Get = () => axios.get('Course/Get');
export const GetAll = () => axios.get('Course/GetAll');
export const GetDetails = (id) => axios.get(`Course/GetDetails?id=${id}`);

export const CourseRegisterStatus = (id) => axios.get(`Course/CourseRegisterStatus?id=${id}`);
export const Register = (data) => axios.post('Course/Register', data);

export const GetOfflineRegistered = (courseId) => axios.get(`Course/GetOfflineRegistered?courseId=${courseId}`);
export const OfflineRegister = (data) => axios.post('Course/OfflineRegister', data);

export const GetCourseUsers = (id) => axios.get(`Course/GetLatestCourseUsersStatus?courseId=${id}`);

export const GetCourseStates =() => axios.get('Course/GetCourseStates');

//Admin
export const Create = (model) => axios.post('Course/Create', model);

export const GetAdminDetails = (id) => axios.get(`Course/GetAdminDetails?id=${id}`);

export const UploadImage = (data) => axios.post('Course/UploadImage', data, {
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'multipart/form-data'
    }
});

export const Update = (data) => axios.post('Course/Update', data);

export const Delete = (id) => axios.post(`Course/Delete?id=${id}`);

